'use client'

import { SignedIn, SignedOut } from '@clerk/nextjs'
import Link from 'next/link'
import AccountDropdown from './AccountDropdown'

export default function AuthHeader() {
  return (
    <div className="flex items-center gap-4 pl-4 h-full">
      <SignedOut>
        <Link href="/sign-in">
          <button className="text-[10px] font-black uppercase tracking-[0.15em] px-4 py-1.5 bg-brand text-white hover:bg-brand/90 transition-all rounded-sm shadow-sm">
            Log In
          </button>
        </Link>
      </SignedOut>
      <SignedIn>
        <AccountDropdown />
      </SignedIn>
    </div>
  )
}
